import { isPlatformBrowser } from '@angular/common';

import { BROWSER_SERVICE, BrowserService, WINDOW_OBJ } from './browser.service';
import { NopService } from './nop.service';
import { WindowService } from './window.service';
import { inject, PLATFORM_ID, Provider } from '@angular/core';

export function browserServiceFactory(
  platformId: string,
  window: Window
): BrowserService {
  if (isPlatformBrowser(platformId)) {
    return new WindowService(window);
  } else {
    return new NopService();
  }
}

export const WINDOW_OBJ_PROVIDER: Provider = {
  provide: WINDOW_OBJ,
  useFactory: () => (isPlatformBrowser(inject(PLATFORM_ID)) ? window : null),
};

export const BROWSER_SERVICE_PROVIDER: Provider = {
  provide: BROWSER_SERVICE,
  useFactory: browserServiceFactory,
  deps: [PLATFORM_ID, WINDOW_OBJ],
};
